module.exports = __webpack_public_path__ + "static/media/3DPPA2.67d072ee.jpg";